import { useTheme, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

import useGetPaletteFromWhiteLabel from '../../../../hooks/useGetPaletteFromWhiteLabel';
import palette from '../../../../theme/learnerPalette';
import AtomGrid from '../../../atoms/AtomGrid';
import { styleConfigs } from '../../../resources/styleConfigs';
import { MIconButton } from '../../../template-minimal/@material-extend';
import MenuPopover from '../../../template-minimal/MenuPopoverComponent/MenuPopover';
import ListItemButtonWrapper from '../../../wrappers/ListItemButtonWrapper';
import ListSubheaderWrapper from '../../../wrappers/ListSubheaderWrapper';
import ListWrapper from '../../../wrappers/ListWrapper';

export const ContainerButtonStyled = styled(MIconButton, {
  shouldForwardProp: (prop) => prop !== 'islearner',
})(({ islearner }: { islearner?: number }) => {
  const wlPalette = useGetPaletteFromWhiteLabel();
  const colorPalette = wlPalette?.text?.prussianBlue ?? palette.light.text.prussianBlue;
  const backgroundColorPalette = islearner
    ? wlPalette?.background?.redViolet ?? palette.light.background.redViolet
    : palette.light.background.yaleBlue;

  return {
    color: colorPalette,
    padding: styleConfigs.marginPadding.empty,
    borderRadius: styleConfigs.borders.radius16,
    '&:hover': {
      backgroundColor: alpha(backgroundColorPalette, 0.1),
    },
  };
});

export const WorldIconContainerStyled = styled(AtomGrid)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBlock: styleConfigs.marginPadding.custom8,
  marginInlineStart: styleConfigs.marginPadding.custom3,
}));

export const MenuPopoverStyled = styled(MenuPopover)(() => ({
  '& .MuiPaper-root': {
    width: styleConfigs.dimensions.width206,
    borderRadius: styleConfigs.borders.radius12,
    [useTheme().breakpoints.down('sm')]: {
      marginBlockStart: styleConfigs.marginPadding.custom15,
      marginInlineStart: styleConfigs.marginPadding.custom10,
    },
  },
}));

export const ListStyled = styled(ListWrapper)(() => ({
  padding: styleConfigs.marginPadding.empty,
}));

export const ListSubheaderStyled = styled(ListSubheaderWrapper)(() => {
  const wlPalette = useGetPaletteFromWhiteLabel();
  const backgroundColorPalette = wlPalette?.text?.prussianBlue ?? palette.light.text.prussianBlue;

  return {
    fontWeight: styleConfigs.fonts.bold,
    fontSize: styleConfigs.fonts.fontSize16,
    lineHeight: styleConfigs.fonts.lineHeight22,
    color: backgroundColorPalette,
    paddingBlock: styleConfigs.marginPadding.custom14,
    paddingInline: styleConfigs.marginPadding.custom17,
    borderBottom: `${styleConfigs.borders.borderLine} ${palette.light.borders.cadetGrey}`,
    borderStartStartRadius: styleConfigs.borders.radius12,
    borderStartEndRadius: styleConfigs.borders.radius12,
  };
});

export const ListItemButtonStyled = styled(ListItemButtonWrapper)(
  ({ activebackground, activeborderradius }: { activebackground: number; activeborderradius: number }) => {
    const wlPalette = useGetPaletteFromWhiteLabel();
    const backgroundColorPalette = wlPalette?.text?.mistBlue ?? palette.light.background.mistBlue;

    return {
      justifyContent: 'space-between',
      fontSize: styleConfigs.fonts.fontSize14,
      lineHeight: styleConfigs.fonts.lineHeight22,
      color: palette.light.text.ebonyClay,
      background: activebackground && alpha(backgroundColorPalette, 0.2),
      paddingBlock: styleConfigs.marginPadding.custom10,
      paddingInline: `${styleConfigs.marginPadding.custom17px} ${styleConfigs.marginPadding.custom21px}`,
      borderBottom: `${styleConfigs.borders.borderLine} ${palette.light.borders.cadetGrey}`,
      borderEndStartRadius: activeborderradius && styleConfigs.borders.radius12,
      borderEndEndRadius: activeborderradius && styleConfigs.borders.radius12,
      '&:hover': {
        background: alpha(backgroundColorPalette, 0.1),
      },
    };
  },
);
